export default __webpack_public_path__ + "static/media/c6.5f0c9289.PNG";